import { createSelector } from 'reselect';

const selectDocumentosState = (state) => state.documentos;

export const makeSelectDocumentosByItemId = (id) =>
  createSelector([selectDocumentosState], (documentos) => {
    return documentos[id] || []; // Will return the same array unless value changes
  });
